import { useEffect, useState } from "react";
import { gql, useQuery } from "@apollo/client";
import { captureException } from "@sentry/react";
import { useSearchParams } from "react-router-dom";

import Messages from "./Messages";

export default () => {
  const [searchParams] = useSearchParams();

  const [showArchived, setShowArchived] = useState(() => {
    const showArchivedStored = JSON.parse(
      localStorage.getItem("show-archived-chats")
    );
    if (showArchivedStored) return showArchivedStored;
    else return false;
  });
  const [messagesMenuOpened, setMessagesMenuOpened] = useState(false);
  const [page, setPage] = useState(() => {
    if (searchParams.get("page")) return Number(searchParams.get("page"));

    return 1;
  });

  const limit = 10;

  // Fetch data
  const GET_CHATS_DATA = gql`
    query GetChatsData($showArchived: Boolean!, $page: Int!, $limit: Int!) {
      chats(showArchived: $showArchived, page: $page, limit: $limit) {
        chats {
          id
          lastMessageCreatedAt
          lastMessage
          lastMessageRead
          lastSenderMe
          username
          profileImage
          blocking
          hidden
          checkmark
        }
        numOfResults
      }
    }
  `;

  const { data, error } = useQuery(GET_CHATS_DATA, {
    variables: {
      showArchived,
      page,
      limit,
    },
    fetchPolicy: "network-only",
    pollInterval: 60000,
  });

  if (error) {
    console.log("error fetching chats", error);
    captureException(error);
  }

  //console.log("data", data);

  const onShowArchivedToggle = () => {
    setMessagesMenuOpened(false);
    setShowArchived((prevState) => !prevState);
  };

  useEffect(() => {
    localStorage.setItem("show-archived-chats", JSON.stringify(showArchived));
  }, [showArchived]);

  const onMessagesMenuClick = () => {
    setMessagesMenuOpened((prevState) => !prevState);
  };

  const closeMessagesMenu = () => {
    setMessagesMenuOpened(false);
  };

  const paginate = (where) => {
    if (where === "previous") setPage((prevState) => prevState - 1);
    if (where === "next") setPage((prevState) => prevState + 1);

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Messages
      data={data}
      messagesMenuOpened={messagesMenuOpened}
      onMessagesMenuClick={onMessagesMenuClick}
      onShowArchivedToggle={onShowArchivedToggle}
      showArchived={showArchived}
      closeMessagesMenu={closeMessagesMenu}
      limit={limit}
      page={page}
      paginate={paginate}
    />
  );
};
